import Logo from '@/components/navigationBar/Logo';
import SNS from '@/components/company/SNS';

const Footer = () => {
  return (
    <div className='bg-[#121212] w-full h-full pb-20 pt-10 md:py-20 flex flex-col gap-6 justify-center items-center'>
      <div className='flex flex-col items-start xl:min-w-[1060px] md:max-w-[760px] max-w-[360px] gap-4 md:gap-6 px-4 md:px-0'>
        <Logo />
        <div className='flex'>
          <SNS />
        </div>
        <div className='flex flex-col gap-2'>
          <p className='text-[#7D7D7D] text-xs md:text-sm'>
            #1103-1, ITBT Building, 222, Wangsimni-ro, Seongdong-gu, Seoul, 
            Republic of Korea
          </p>
          <p className='text-[#7D7D7D] text-xs md:text-sm'>371-87-02255</p>
          <p className='text-[#7D7D7D] text-xs md:text-sm'>
            SPACEMAP Inc.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
